import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "@/lib/api";
import { setReferral } from "@/lib/referral";

export default function ReferralRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const c = (code || "").toLowerCase();
    if (!c) {
      navigate("/", { replace: true });
      return;
    }
    // hold the invitation for 30 days (localStorage + cookie), log the click,
    // and resolve the house name for the welcome banner — then land on the homepage
    api.get(`/affiliate/brand/${c}`)
      .then((r) => setReferral(c, r.data?.found ? r.data.brand : ""))
      .catch(() => setReferral(c))
      .finally(() => {
        api.post("/affiliate/click", { code: c, ref: document.referrer || "" }).catch(() => {});
        navigate("/", { replace: true });
      });
  }, [code, navigate]);

  return null;
}
